import { gql } from '@apollo/client';

export const CONTRACT_DATA_FRAGMENT = gql`
  fragment PersonalizedContractData on ContractVersion {
    id
    displayName
    internalName
    contractType
    fileUrl
    hasPersonalization
    scrollRequired
    signatureType
    contractId
    version
    stateId
    base64PerchPersonalizedFile
    presignedUrl
    base64PerchPersonalizedFiles {
      utilityAccountId
      base64PerchPersonalizedFile
      perchPersonalizedError
    }
    perchPersonalizedError
    contractVersionLanguage {
      id
    }
  }
`;

export const FETCH_PERSONALIZED_SIGNUP_CONTRACT_SET = gql`
  ${CONTRACT_DATA_FRAGMENT}

  query Flex_FetchPersonalizedSignupContractSetFromTemplate(
    $input: PersonalizedSignupContractSetInput!
  ) {
    personalizedSignupContractSet(input: $input) {
      contractSet {
        contracts {
          ...PersonalizedContractData
        }
      }
    }
  }
`;
